<template>
  <v-select
    prepend-inner-icon="mdi-list-status"
    closable-chips
    clearable
    v-model="internalValue"
    :items="items"
    auto-select-first="exact"
    item-title="label"
    item-value="id"
    :label="label"
    chips
    :multiple="multiple"
  />
</template>

<script>
import { computed } from 'vue'

export default {
  name: 'StatesSelector',
  props: {
    modelValue: {
      type: [Array, String, Number, Object],
      default: () => []
    },
    items: {
      type: Array,
      default: () => []
    },
    label: {
      type: String,
      default: ''
    },
    multiple: {
      type: Boolean,
      default: true
    }
  },
  emits: ['update:modelValue'],
  setup (props, { emit }) {
    const internalValue = computed({
      get: () => props.modelValue,
      set: (val) => emit('update:modelValue', val)
    })

    return {
      internalValue
    }
  }
}
</script>
